export const head: { id: number; label: string }[] = [
  { id: 0, label: "ID" },
  { id: 1, label: "Даты" },
  { id: 2, label: "Автомобиль" },
  { id: 3, label: "Клиент" },
  { id: 4, label: "Сумма" },
  { id: 5, label: "Действия" },
];
